module.exports = __webpack_public_path__ + "static/media/SundayClarendons.1bfe135a.woff2";